import { fromJS } from 'immutable';

import handleDefault from '../handleDefault';

const ENTITY_IDENTIFIER = 'entityViews';
const initialState = fromJS({
  entities: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    default:
      return handleDefault(ENTITY_IDENTIFIER)(state, action);
  }
}
